import React from "react";
import { Heading } from "../../../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../design/table";
import { useFile } from "../../../../contexts/FileContext";
import { useFolder } from "../../../../contexts/FolderContext";
import EmptyStateView from "../../../../components/EmptyStateView";
import FileListItem from "./FileListItem";
import FolderListItem from "./FolderListItem";
import LoadingView from "../../../../components/LoadingView";
import ErrorView from "../../../../components/ErrorView";
import TasksComponent from "../../../../components/TaskComponent/TasksComponent";

const FileListPage: React.FC = () => {
  const { files, error, loading } = useFile();
  const { folders } = useFolder();

  if (loading.list) {
    return <LoadingView title="Loading Files..." />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  const sortedFiles = files
    .filter((file) => file.type === "evidence")
    .filter((file) => file.folderId === undefined)
    .sort((a, b) => a.name.localeCompare(b.name));
  const sortedFolders = folders
    .filter((folder) => folder.folder === undefined)
    .sort((a, b) => a.name.localeCompare(b.name));
  const sortedItems = [...sortedFolders, ...sortedFiles];

  return (
    <div>
      <TasksComponent taskType="evidence" />

      {sortedItems.length === 0 && (
        <EmptyStateView
          title="No Files"
          message="No files found. Create some to get started."
        />
      )}
      {sortedItems.length > 0 && (
        <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader className="text-left">Name</TableHeader>
              <TableHeader className="text-left">Type</TableHeader>
              <TableHeader className="text-right">Size</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedFolders.map((folder) => (
              <FolderListItem key={folder._id} folder={folder} />
            ))}
            {sortedFiles.map((file) => (
              <FileListItem key={file._id} file={file} />
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default FileListPage;
